import Banner from "../components/Banner";
import ExploreSlider from "../components/ExploreSlider";
import RegisterCallout from "../components/RegisterCallout";
import ExploreNearData25 from "../data/ExploreNearData25";
import ExploreFarData25 from "../data/ExploreFarData25";

export default function PageExplore() {
  return (
    <>
      <Banner className="bg-white-after">
        <div className="col-12 mb-3">
          <div className="display-1 color-white">Explore San Diego</div>
        </div>
        <div className="col-12 col-md-9 col-lg-8 col-xl-7 mb-2">
          <p className="color-white mb-0">
            Discover what's just steps away or a short ride from Estancia La
            Jolla during FinComp 2025.
          </p>
        </div>
      </Banner>

      <section className="sliders">
        <ExploreSlider
          title="On or Near the Resort"
          subTitle="Discover something new at these walkable destinations"
          data={ExploreNearData25}
        />

        <br />

        <ExploreSlider
          title="Worth the Drive"
          subTitle="Want to extend your trip or sneak in an adventure? These are just a short Uber away."
          data={ExploreFarData25}
        />
      </section>

      <RegisterCallout className="bg-before-white" />
    </>
  );
}
